import { useEffect, useState } from "react";
import LoadingSpinner from "../../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import PrimaryButton from "../../../../../../sharedComponents/primaryButton/PrimaryButton";
import { Link } from "react-router-dom";
import CancelButton from "../../../../../../sharedComponents/cancelButton/CancelButton";
import { Divider } from "rsuite";
import { Checkbox, FormControlLabel, /* Tooltip */ } from "@mui/material";
import axios from "axios";
import './AreaChangeAssignment.css'
/* import { Button, Modal } from "react-bootstrap"; */

function AreaChangeAssignment(){

    const [isLoading, setIsLoading] = useState(true);
    const [id] = useState(sessionStorage.getItem("area-id"));
    const [areaEmployees, setAreaEmployees] = useState(null);

    /* const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const [showAllAssignmentModal, setShowAllAssignmentModal] = useState(false);

    const handleShowAssigmentModal = () => setShowAssignmentModal(true);
    const handleCloseAssigmentModal = () => setShowAssignmentModal(false);

    const handleShowAllAssigmentModal = () => setShowAllAssignmentModal(true);
    const handleCloseAllAssigmentModal = () => setShowAllAssignmentModal(false); */

    /* const [selectedEmployee, setSelectedEmployee] = useState(null); */
    const [selectedAllEmployees, setSelectedAllEmployees] = useState(true);

    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        getAreaAssignedEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAreaAssignedEmployees() {
        axios.get('area').then(results => {
            axios.get('employee/getActive')
            .then(allResults => {
                const thisArea = results.data.find((element) => element.id === id).assigned_employee_ids;
                const allEmployees = allResults.data;                

                const employeesWithAssignmentStatus = allEmployees.map(employee => {
                    const isAssigned = thisArea.includes(employee.id);                    
                    return {
                        ...employee,
                        isAssigned: isAssigned
                    };
                });

                employeesWithAssignmentStatus.forEach((employee) => {
                    if (employee.isAssigned === false) {
                        setSelectedAllEmployees(false);
                    }
                })

                setAreaEmployees(employeesWithAssignmentStatus);
                setIsLoading(false);                
            })
            .catch(error => {console.log(error);
            });
        }).catch(() => {console.log("error");
        })
    }

    const saveEmployeeAssignment = () => {
        const assignedEmployeeIds = areaEmployees
            .filter(employee => employee.isAssigned)
            .map(employee => employee.id)

        const notAssignedEmployeeIds = areaEmployees
            .filter(employee => !employee.isAssigned)
            .map(employee => employee.id)        
        
        if(assignedEmployeeIds.length !== 0 && notAssignedEmployeeIds.length !== 0) {
            axios.post("area/" + id + "/assign-employees", {
                "employee_ids": assignedEmployeeIds
            }).then(() => {
                axios.post('area/' + id + '/remove-employees', {
                    "employee_ids": notAssignedEmployeeIds
                }).then(() => {
                    window.location.assign("/home/settings/bereiche/detailView?id=" + id);
                })            
            })
        } else if(assignedEmployeeIds.length === 0){
            axios.post('area/' + id + '/remove-employees', {
                "employee_ids": notAssignedEmployeeIds
            }).then(() => {
                window.location.assign("/home/settings/bereiche/detailView?id=" + id);
            })
        } else if(notAssignedEmployeeIds.length === 0){
            axios.post("area/" + id + "/assign-employees", {
                "employee_ids": assignedEmployeeIds
            }).then(() => {
                window.location.assign("/home/settings/bereiche/detailView?id=" + id);
            })
        }      
    }

    const handleEmployeeSelection = (employee, event) => {
        employee.isAssigned=event.target.checked; 
        employee.assigned_core_working_hours_policy_id = null; 
        setSelectedAllEmployees(areaEmployees.filter(item => item.isAssigned === true).length === areaEmployees.length);
        setRefresh(!refresh);
    }

    function generateEmployeeSelection() {
        let employeeSelection = [];        

        areaEmployees.forEach((employee, index) => {
            employeeSelection.push(
                <div className="area-employee-item" key={index}>
                    <FormControlLabel 
                        control={
                            <Checkbox checked={employee.isAssigned} 
                                onChange={event => handleEmployeeSelection(employee, event)}
                            />
                        } 
                        label={employee.first_name + " " + employee.last_name} />
                </div>
            )
        })

        /* areaEmployees.forEach((employee, index) => {            
            if (!employee.isAssigned && employee.assigned_area_ids.length !== 0 && !employee.assigned_area_ids.includes(id)) {
                employeeSelection.push(
                    <div className="area-employee-item" key={index} onClick={() => { handleShowAssigmentModal(); setSelectedEmployee(employee)}} >
                        <Tooltip placement="right" arrow title="Anderer Regelung zugewiesen. Zum Überschreiben klicken" >
                            <FormControlLabel control={<Checkbox checked={false} disabled={true} />} label={employee.first_name + " " + employee.last_name} />
                        </Tooltip>
                    </div>
                )
            } else {
                employeeSelection.push(
                    <div className="area-employee-item" key={index}>
                        <FormControlLabel 
                            control={
                                <Checkbox checked={employee.isAssigned} 
                                    onChange={event => handleEmployeeSelection(employee, event)}
                                />
                            } 
                            label={employee.first_name + " " + employee.last_name} />
                    </div>
                )
            }
        }) */

        return employeeSelection;
    }

    /* const activateBlockedEmployee = () => {
        axios.post('area/' + id + '/remove-employees', {
            "employee_ids": [selectedEmployee.id]
        }).then(response => {
            let isSelectedAllEmployees = true;
            areaEmployees.forEach((employee) => {
                if (employee.isAssigned === false) {
                    isSelectedAllEmployees = false;
                }
            })
            setSelectedAllEmployees(isSelectedAllEmployees);
            selectedEmployee.isAssigned = true; 

            handleCloseAssigmentModal();
            setRefresh(!refresh);
        }).catch(error => {
            console.log("Fehler beim Löschen!");
        })
    } */

    /* function CreateAssigmentModal() {
        return (
            <Modal
                show={showAssignmentModal}
                onHide={handleCloseAssigmentModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>Mitarbeiter auswählen</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={handleCloseAssigmentModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>Möchten Sie den Mitarbeiter auswählen?</p>
                    <p className="red-color">Achtung: Mitarbeiter ist einer anderen Regel zugewiesen. Bei Bestätigung wird dieser aus seiner aktuellen Regelung entfernt.</p>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton text="Abbrechen" onClick={handleCloseAssigmentModal} />
                    <Button variant="danger" onClick={activateBlockedEmployee}>Aus Regelung entfernen</Button>
                </Modal.Footer>
            </Modal>
        )
    } */

    /* function CreateAllAssignmentModal() {
        return (
            <Modal
                show={showAllAssignmentModal}
                onHide={handleCloseAllAssigmentModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>Alle Mitarbeiter auswählen</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={handleCloseAllAssigmentModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>Möchten Sie alle Mitarbeiter auswählen?</p>
                    <p className="red-color">Achtung: Einige Mitarbeiter sind noch einer anderen Regelung zugeordnet. Bei Bestätigung werden diese aus der alten Regelung entfernt.</p>
                    <strong>Betroffene Mitarbeiter:</strong>
                    {generateBlockedEmployees()}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton text="Abbrechen" onClick={handleCloseAllAssigmentModal} />
                    <Button variant="danger" onClick={selectAllEmployees}>Alle Regelungen entfernen</Button>
                </Modal.Footer>
            </Modal>
        )
    } */

    /* function generateBlockedEmployees() {
        let blockedEmployeeArray = [];

        areaEmployees.forEach((employee) => {
            if ((employee.assigned_area_ids.length !== 0) && (!employee.assigned_area_ids.some(element => element === id))) {
                blockedEmployeeArray.push(
                    <p className="blocked-employee-item">{employee.first_name + " " + employee.last_name}</p>
                )
            }
        })
        return blockedEmployeeArray;
    }

    const selectAllEmployees = () => {
        const removingEmployeeIds = areaEmployees
            .filter(employee => !employee.isAssigned && employee.assigned_area_ids.length !== 0)
            .map(employee => employee.id);

        axios.put('area/' + id + '/remove-employees', {
            "employee_ids": removingEmployeeIds
        }).then(response => {
            areaEmployees.forEach((employee) => {employee.isAssigned = true; employee.assigned_area_ids = []});
            setSelectedAllEmployees(true);
            handleCloseAllAssigmentModal();
            setRefresh(!refresh);
        }).catch(error => {
            console.log("Fehler beim alle Löschen!");
        })
    } */

    const handleAllEmployeeSelection = () => {        
        if (selectedAllEmployees) {
            areaEmployees.forEach(employee => {
                employee.isAssigned = false;
            })
            setSelectedAllEmployees(false);
        } else {
           areaEmployees.forEach(employee => {
                employee.isAssigned = true;
            })
            setSelectedAllEmployees(true);
        }
    }

    return isLoading ?
        <LoadingSpinner />
        :
        <>
            <div className="area-assignment-container">
                <div className="area-assignment-header">
                    <Link to={"/home/settings/bereiche/detailView?id=" + id}><CancelButton text="Abbrechen" /></Link>
                    <PrimaryButton onClick={saveEmployeeAssignment} text="Speichern" />
                </div>
                <Divider />
                <h4>Mitarbeiter zuweisen</h4>
                <div className="area-employee-item">
                    <FormControlLabel control={<Checkbox checked={selectedAllEmployees} onChange={handleAllEmployeeSelection} />} label="Alle auswählen" />
                </div>
                <Divider />
                <div className="area-employee-form">
                    {generateEmployeeSelection()}
                </div>
            </div>
            {/* <CreateAssigmentModal /> */}
            {/* <CreateAllAssignmentModal /> */}
        </>
}

export default AreaChangeAssignment;